import React from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import HowToBuyContent from '../../components/HowToBuyContent';

const HowToBuyPage = () => {
  return (
    <ProfileLayout activeItem="purchase">
      <HowToBuyContent videoSrc="/video_how_to_buy.mp4" />
    </ProfileLayout>
  );
};

export default HowToBuyPage;
